import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import accountService from "./accountService";

const api: AxiosInstance = axios.create({
    baseURL: "/api",
    withCredentials: true,
});

// Add JWT token to every request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('JWT');
        if (token) 
            config.headers.Authorization = `Bearer ${token}`;
        
        return config;
    },
    (error) => Promise.reject(error)
);

// Redirect to login on 401 (Unauthorised) response
api.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
        if (error.response.status === 401) {

            //User has a token, but still unauthorized. Likely an expired token. Log them out to generate new token.
            if (accountService.getAccessToken()) 
                accountService.logOut();

            const currentPath = window.location.pathname;
            if (!currentPath.includes("register") || !currentPath.includes("login"))
                window.location.replace(`/account/login?redirect=${encodeURIComponent(currentPath)}`);
        }
        return Promise.reject(error);
    }
);

//Custom redirect status code from back-end
api.interceptors.response.use((response) => {
  if (response.status === 278 && response.data.redirectUrl) {
    window.location.href = response.data.redirectUrl; 
  }
  return response;
});

// Interceptor to attach XSRF token to write requests
api.interceptors.request.use((config) => {
    //Make sure this is never overwritten.
    config.withCredentials = true;

    if (["post", "put", "delete"].includes(config.method)) {
        const token = getCookie("XSRF-TOKEN");
        if (token) {
            config.headers["X-XSRF-TOKEN"] = token;
        }
    }
    return config;
});

export default api;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
